import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import SectionHeader from "../SectionHeader";
import { laws } from "../../../../content/laws";

import style from "./styles.module.scss";

const keyI18n = "translations.aboutPgm.laws";

export default function LawsSection() {
  const { t } = useTranslation();
  const [openIds, setOpenIds] = useState<string[]>([]);

  const toggle = (id: string) =>
    setOpenIds((current) =>
      current.includes(id)
        ? current.filter((openId) => openId !== id)
        : [...current, id],
    );

  return (
    <section className={style.laws} id="leis-complementares">
      <SectionHeader
        label={t(`${keyI18n}.label`)}
        title={t(`${keyI18n}.title`)}
      />

      <ul className={style.list}>
        {laws.map(({ id, title, syllabus, amendments }) => {
          const open = openIds.includes(id);

          return (
            <li className={style.item} key={id}>
              <button
                aria-controls={`${id}-content`}
                aria-expanded={open}
                className={style.trigger}
                id={`${id}-trigger`}
                onClick={() => toggle(id)}
                type="button"
              >
                <span className={style.itemTexts}>
                  <span className={`pgm-title-medium ${style.itemTitle}`}>{title}</span>
                  <span className={`pgm-body-medium ${style.count}`}>
                    {amendments.length} {t(`${keyI18n}.amendmentsLabel`)}
                  </span>
                </span>
                <span aria-hidden="true" className={`material-symbols-sharp ${style.chevron}`}>
                  {open ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
              </button>

              {open && (
                <div
                  aria-labelledby={`${id}-trigger`}
                  className={style.content}
                  id={`${id}-content`}
                >
                  <p className={`pgm-body-large ${style.syllabus}`}>{syllabus}</p>
                  <ul className={style.amendments}>
                    {amendments.map((amendment, index) => (
                      <li className="pgm-body-medium" key={index}>
                        {amendment}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
